import React, { Fragment, useEffect, useState } from 'react'
import "./Profile.scss"
import { useDispatch, useSelector } from 'react-redux'
// import ProfilePicture from '../../components/ProfilePicture/ProfilePicture'
// import { updateUser } from '../../Reducers/actions/authActions'
import CardButton from '../../components/CardButton/CardButton'
import Icon from '../../components/Icon/Icon'
import { supabase } from '../../../supabase'
import { useNavigate } from 'react-router-dom'
// import { fetchUpdateProfilePic } from '../../Reducers/actions/userActions'
import MenuProfile from '../../components/MenuProfile/MenuProfile'
import { setTopNavbar } from '../../Reducers/actions/navbarActions'
import { USER_ROLES } from '../../constants/globals'
import ModalMessage from '../../components/ModalMessage/ModalMessage'
import { fromCentsToPounds } from '../../../helpers/money'
import { getBalance } from '../../Reducers/actions/accountActions'
import { ProfileBalanceSkeleton } from '../../components/Skeletons/BatchScreenSkeletons'
import { MAX_INVITES, INVITE_PATH } from '../../constants/invitations'
import ShippingAddresses from '../ShippingAddresses/ShippingAddresses'
import useSocialNetworksPrompt from '../../hooks/useSocialNetworksPrompt'
import SocialNetworksPrompt from '../../components/SocialNetworksPrompt/SocialNetworksPrompt'
import { getUserDisplayName } from '../../../helpers/userDisplayName'

const BASE_URL = import.meta.env.VITE_SUPABASE_REDIRECT_URL

const DashItem = ({ icon, title, subtitle, action }) => {
    return (
        <div className='dash-item d-flex f-row aic mb-16 pb-16 action-item' onClick={action}>
            <div className='dash-icon'>
                {/* <Icon alias={'orders'} color='#1C1B1F' width={32} height={32} /> */}
                {icon}
            </div>
            <div className='dash-group d-flex aic w-full ml-16'>
                <div className='dash-item-content'>
                    <p className='fg-dark fw-medium-bold my-0 fw-bold'>{title}</p>
                    <p className='fg-dark fs-real fs-xs my-0 fw-medium'>{subtitle}</p>
                </div>
                <Icon className={"action-icon ml-auto mt-4"} alias={"chevron-right"} color='#777' width={24} />
            </div>
        </div>
    )
}

const Creator = (props) => {
    const { user, handleLogout } = props
    const navigate = useNavigate()
    const [isUserLoaded, setIsUserLoaded] = useState(false)
    const [copySuccess, setCopySuccess] = useState(false)
    const [openLogoutModal, setOpenLogoutModal] = useState(false)

    // Social networks prompt modal (share button clicked trigger - immediate)
    const socialNetworksPrompt = useSocialNetworksPrompt('share');

    useEffect(() => {
        if (user) {
            setIsUserLoaded(true)
        }
    }, [user])

    const inviteLink = user?.userName 
        ? `${BASE_URL}${INVITE_PATH}?code=${encodeURIComponent(user.userName)}`
        : '';

    const handleShareLink = async () => {
        // Check if social networks prompt should be shown
        if (socialNetworksPrompt.shouldShow) {
            socialNetworksPrompt.openModal();
        }
        if (navigator.share) {
            try {
                const shareTitle = "Join me on HYK 🎨";
                const shareText = `🎨 Discover and share amazing art!
                    Join me on HYK and explore a world of creativity.
                👉 ${inviteLink}`;

                await navigator.share({
                    title: shareTitle,
                    text: shareText,
                    url: inviteLink,
                });

            } catch (err) {
                console.error("Error sharing:", err);
            }
        }
        else {
            alert("Sharing is not supported on this device.");
        }
    }
    const handleCopyLink = async (e) => {
        e.stopPropagation();
        if (!inviteLink) {
            alert("Please set a username before copying your invite link.");
            return;
        }
        try {
            await navigator.clipboard.writeText(inviteLink);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000); // Reset after 2 seconds
        } catch (err) {
            console.error('Failed to copy link:', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = inviteLink;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
    }

    const remainingInvites = isUserLoaded ? MAX_INVITES - (user?.nbInvites ?? 0) : null

    return (
        <Fragment>
            {socialNetworksPrompt.isOpen && (
                <SocialNetworksPrompt 
                    open={socialNetworksPrompt.isOpen} 
                    onClose={socialNetworksPrompt.closeModal} 
                />
            )}
            {openLogoutModal &&
                <ModalMessage onClose={() => setOpenLogoutModal(false)}>
                    <div className="delete-confirmation d-flex f-column aic jcc">
                        <p className='fs-sm2 fw-bold mb-32 mt-32'>Are you sure you want to logout?</p>
                        <button className="btn red-outline-btn btn-full aic jcc fw-extra-bold mb-24" style={{ height: '64px' }} onClick={handleLogout}>YES, LOGOUT</button>
                        <p className="fs-xxs fg-dark fw-bold mb-16 mt-0 c-pointer td-underline" onClick={() => setOpenLogoutModal(false)}>CANCEL</p>
                    </div>
                </ModalMessage>}
            <div className='action-container p-16'>
                <CardButton
                    key="creations"
                    classNames="mb-32"
                    icon={<Icon alias={'community'} color='#FFF' width={64} height={64} />}
                    title={"Invite your community"}
                    subtitle={isUserLoaded ? `${remainingInvites} remaining invites` : 'Loading invites...'}
                    onClick={() => navigate('/invite-community')}
                    children={
                        <div className='d-flex aic' onClick={handleCopyLink}>
                            <p className='fs-real fg-white fw-medium my-0 invite-link'>{inviteLink}</p>
                            <div className='d-flex aic ml-auto'>
                                <Icon
                                    alias={'share_android'}
                                    width={24}
                                    color={"#FFF"}
                                    onClick={handleShareLink}
                                />
                                <Icon
                                    className={"ml-12"}
                                    alias={copySuccess ? 'check' : 'copy_invite_link'}
                                    width={24}
                                    color={"none"}
                                    stroke={"#FFF"}
                                    strokeWidth={2}
                                />
                            </div>


                        </div>
                    }
                />
                {copySuccess && <p className="copy-success">Link copied to clipboard!</p>}

                <div className='d-flex f-column'>


                    <DashItem
                        icon={<Icon alias={'person'} color='#1C1B1F' width={32} height={32} />}
                        title={'Account'}
                        subtitle={'Edit personal information'}
                        action={() => navigate('/edit-profile')}
                    />
                    <DashItem
                        icon={<Icon alias={'shipment'} color='#1C1B1F' width={32} height={32} />}
                        title={'My purchases'}
                        subtitle={'Track your purchases'}
                        action={() => navigate('/shipments')}
                    />
                    
                    <DashItem
                        icon={<Icon alias={'house'} color='#1C1B1F' width={32} height={32} />}
                        title={'Shipping addresses'}
                        subtitle={'Manage your shipping addresses'}
                        action={() => navigate('/shipping-addresses')}
                    />
                    <DashItem
                        icon={<Icon alias={'payment'} color='#1C1B1F' width={32} height={32} />}
                        title={'Payment history'}
                        subtitle={"View payments you've made"}
                        action={() => navigate('/payments-history')}
                    />
                    <DashItem
                        icon={<Icon alias={'feedback'} color='none' stroke={"#1C1B1F"} strokeWidth={2} width={32} height={32} />}
                        title={'Feedback'}
                        subtitle={"Give us your feedback"}
                        action={() => window.open('https://forms.gle/qGUUQ72pozC6deLf7', '_self')}
                    />
                    <DashItem
                        icon={<Icon alias={'book'} color='#1C1B1F' width={32} height={32} />}
                        title={'Terms & Conditions'}
                        subtitle={'Read our terms of service'}
                        action={() => navigate('/terms')}
                    />
                    <DashItem
                        icon={<Icon alias={'info'} color='#1C1B1F' width={32} height={32} />}
                        title={'Privacy Policy'}
                        subtitle={'How we handle your data'}
                        action={() => navigate('/privacy')}
                    />
                </div>
                <div className='d-flex f-row aic mb-16 pb-16' onClick={() => setOpenLogoutModal(true)}>
                    <div>
                        <p className='fg-red-pink fs-real fw-medium my-0'>Logout</p>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

const Other = (props) => {
    const { user } = props
    const dispatch = useDispatch()
    const { balance, balanceLoading } = useSelector((state) => ({
        balance: state?.account?.balance,
        balanceLoading: state?.account?.balanceLoading,

    }))
    useEffect(() => {
        dispatch(getBalance());

    }, [])
    const navigate = useNavigate()
    if (balanceLoading) {
        return <ProfileBalanceSkeleton />
    }

    return (
        <div className='action-container p-16'>
            <div className='d-flex f-column'>
                <CardButton
                    key="creations"
                    classNames="mb-32"
                    icon={<Icon alias={'house'} color='#FFF' width={49} height={49} />}
                    title={`${fromCentsToPounds(balance?.available?.amount ?? balance?.amount ?? 0)}`}
                    subtitle={`Available Balance`}
                    onClick={() => { }}
                />
                <DashItem
                    icon={<Icon alias={'compass'} color='#1C1B1F' width={32} height={32} />}
                    title={'Analytics'}
                    subtitle={'View insights and make decisions.'}
                    action={() => navigate('/creator-analytics')}
                />
                <DashItem
                    icon={<Icon alias={'dollar_bill'} color='#1C1B1F' width={32} height={32} />}
                    title={'Withdrawals'}
                    subtitle={'Send money to your account'}
                    action={() => navigate('/withdrawals')}
                />
                <DashItem
                    icon={<Icon alias={'package_sales'} color='#1C1B1F' width={32} height={32} />}
                    title={'My Sales'}
                    subtitle={'Manage new orders'}
                    action={() => navigate('/orders')}
                />
                <DashItem
                    icon={<Icon alias={'dollar'} color='#1C1B1F' width={32} height={32} />}
                    title={'Earnings'}
                    subtitle={'Follow your income'}
                    action={() => navigate('/earnings')}
                />
                <DashItem
                    icon={<Icon alias={'shipment'} color='#1C1B1F' width={32} height={32} />}
                    title={'Shipping Methods'}
                    subtitle={'Manage your delivery rates.'}
                    action={() => navigate('/shipping-methods')}
                />

            </div>
        </div>
    )
}
const MENU_ITEMS = [
    {
        name: 'creator',
        label: 'SETTINGS',
        render: (props) => <Creator {...props} />,
        disabled: (user) => user?.role === 'user'

    },
    {
        name: 'other',
        label: 'DASHBOARD',
        render: (props) => <Other {...props} />,
        disabled: (user) => user?.role === USER_ROLES.customer
    }
]

const Profile = () => {
    const user = useSelector((state) => state.auth?.user || null);
    const active_settings = useSelector((state) => state.auth.active_settings)

    const [selected, setSelected] = useState(MENU_ITEMS[active_settings] || MENU_ITEMS[0])

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(setTopNavbar({
            title: 'Account',
            showBackArrow: true
        }))

    }, [])

    // const onImageUpload = (obj) => {
    //     fetchUpdateProfilePic(obj, user.user_id).then(({ success, data }) => {
    //         if (success) {
    //             dispatch(updateUser({ profilePicture: data }))
    //             localStorage.setItem("pdp", data)
    //         }
    //     })
    // }

    const handleLogout = async (e) => {
        e.preventDefault()
        const { error } = await supabase.auth.signOut();
        if (!error) {
            dispatch({
                type: 'RESET_USER'
            })
            dispatch({
                type: 'RESET_SESSION'
            })
            localStorage.removeItem("email")
            localStorage.removeItem("pdp")
            navigate("/login");
        } else {
            console.error("Logout Error:", error.message);
        }
    };

    // const handleEditProfile = (e) => {
    //     e.preventDefault();
    //     navigate("/edit-profile")
    // }
    // const pdp = localStorage.getItem("pdp")

    const handleSelected = (item) => {
        setSelected(item)
        dispatch({
            type: 'SET_ACTIVE_SETTINGS',
            payload: MENU_ITEMS.findIndex(el => el.name === item.name)
        })
    }
    return (
        <div className='pt-32 pb-40 mt-40 settings-page'>
            {/* <div className='profile-container p-16 mt-40'>
                <div className='d-flex f-column aic'>
                    <ProfilePicture imgUrl={!pdp || pdp === 'null' || pdp.length === 0 ? user?.profilePicture : pdp} onImageUpload={onImageUpload} />
                    <div className='profile-info ta-center mb-32'>
                        <p className='fg-black fw-medium mt-8 mb-0'>{getUserDisplayName(user)}</p>
                        <p className='fg-hyk-medgrey mt-0 mb-12'>{user?.address || "Algiers"}</p>
                        <button className='btn-outline-white btn-sm' onClick={handleEditProfile}>Edit profile</button>
                    </div>
                    <div className='profile-stat d-flex f-row aic'>
                        <div className='ta-center px-24'>
                            <p className='fg-black fs-xs mb-0'>12</p>
                            <p className='fg-hyk-medgrey mt-0'>Creations</p>
                        </div>
                        <div className='vertical-line bg-ash-grey'></div>
                        {user?.is_creator && <Fragment>
                            <div className='ta-center px-24'>
                                <p className='fg-black fs-xs mb-0'>12</p>
                                <p className='fg-hyk-medgrey mt-0'>Followers</p>
                            </div>
                            <div className='vertical-line bg-ash-grey'></div>
                        </Fragment>}
                        <div className='ta-center px-24'>
                            <p className='fg-black fs-xs mb-0'>12</p>
                            <p className='fg-hyk-medgrey mt-0'>Follows</p>
                        </div>
                    </div>
                </div>
            </div> */}
            <MenuProfile
                menu_items={MENU_ITEMS}
                selected={selected}
                setSelected={handleSelected}
                handleLogout={handleLogout}
                user={user}
            />
        </div>
    )
}

export default Profile